import { Modal, Box } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { ModalStyle } from "../../../../helpers/appHelpers";
import { useResendConfirmationPassword } from "../../../../services/auth.service";
import useEditFormStore from "../../../../state-management/useEditFormStore";

interface ResendConfirmationProps {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const ResendConfirmation = ({ open, setOpen }: ResendConfirmationProps) => {
	const { formDataValues } = useEditFormStore();
    const [uploading, setUploading] = useState(false);
    const { mutate: resendConfirmation } = useResendConfirmationPassword();

    const handleModeAction = () => {
        setUploading(true);
        
        resendConfirmation(
            { payload: { username: formDataValues?.username } },
            {
                onSuccess: () => {
                    toast.success("New confirmation email sent successfully!");
                    setOpen(false);
                },
                onError: () => setUploading(false),
            }
        )
    };

	return (
		<Modal
			open={open}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={ModalStyle} width={400}>
				<p className="text-center">
                    Are you sure you want to resend an account confirmation email for
                    <span className="font-semibold">{" "}{formDataValues?.firstName} {formDataValues?.lastName}'s</span>
                    {" "}account?
				</p>

				<div className="flex w-full justify-center space-x-4 items-center mt-10 whitespace-nowrap">
					<button
						onClick={() => setOpen(false)}
						className={`px-12 py-4 border text-gray-400 hover:text-gray-500 border-gray-300 rounded-lg text-2xs ${uploading && "opacity-50"}`}
						disabled={uploading}
					>
						Cancel
					</button>
					<button
						onClick={handleModeAction}
						className="px-12 py-4 border text-white rounded-lg text-2xs hover:opacity-90 bg-primary-mango"
						disabled={uploading}
					>
                        {uploading ? "Disabling..." : "Yes, Resend"}
					</button>
				</div>
			</Box>
		</Modal>
	);
};

export default ResendConfirmation;